import React, { useEffect, useRef } from 'react';
import { XIcon, ClockIcon, CheckCircleIcon, AlertTriangleIcon, InfoIcon } from 'lucide-react';
interface Log {
  time: string;
  message: string;
  status: 'success' | 'error' | 'warning' | 'info';
}
interface SettingsPanelProps {
  logs: Log[];
  onClose: () => void;
}
export const SettingsPanel: React.FC<SettingsPanelProps> = ({
  logs,
  onClose
}) => {
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);
  const getStatusIcon = (status: Log['status']) => {
    switch (status) {
      case 'success':
        return <CheckCircleIcon size={16} className="text-green-500" data-id="element-153" />;
      case 'error':
        return <AlertTriangleIcon size={16} className="text-red-500" data-id="element-154" />;
      case 'warning':
        return <AlertTriangleIcon size={16} className="text-orange-500" data-id="element-155" />;
      case 'info':
        return <InfoIcon size={16} className="text-blue-500" data-id="element-156" />;
    }
  };
  return <div className="fixed inset-0 z-50 flex items-start justify-end p-4 bg-black bg-opacity-30" data-id="element-157">
      <div ref={panelRef} className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md h-[80vh] flex flex-col" data-id="element-158">
        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-159">
          <div className="flex items-center" data-id="element-160">
            <ClockIcon size={20} className="mr-2" data-id="element-161" />
            <h3 className="text-lg font-medium" data-id="element-162">Activity Log</h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300" aria-label="Close" data-id="element-163">
            <XIcon size={20} data-id="element-164" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4" data-id="element-165">
          <div className="space-y-2" data-id="element-166">
            {logs.map((log, index) => <div key={index} className="flex items-start p-3 rounded-md bg-gray-50 dark:bg-gray-750" data-id="element-167">
                <div className="mr-2 mt-0.5" data-id="element-168">{getStatusIcon(log.status)}</div>
                <div className="flex-1" data-id="element-169">
                  <div className="flex justify-between items-start" data-id="element-170">
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-171">
                      {log.time}
                    </span>
                  </div>
                  <p className="text-sm mt-1" data-id="element-172">{log.message}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};